import {
  Card,
  CardActions,
  CardMedia,
  Container,
  CssBaseline,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from '@material-ui/core';
import {
  HomeOutlined as HomeLinkIcon,
  SchoolOutlined as UsersLinkIcon,
  PeopleOutlined as StudentsLinkIcon,
} from '@material-ui/icons';
import Axios from 'axios';
import React, {useEffect, useState} from 'react';
import {Link, Route, Switch} from 'react-router-dom';
import Image from '../../assets/meterhero-logo-yellow.png';
import SkipNavigation from '../../components/SkipNavigation';
import TeacherClassroomsTable from '../../components/TeacherClassroomsTable';
import TeacherStudentsTable from '../../components/TeacherStudentsTable';
import {screenReaderOnly} from '../../utils/screenReaderOnly';

const drawerWidth = '300px';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    color: 'white',
    backgroundColor: '#263238',
    width: drawerWidth,
  },
  drawerHeader: {
    height: '30vh',
    padding: '1.5em 4em',
  },
  content: {
    flexGrow: 1,
    height: '100%',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
}));

export function TeacherDashboard() {
  const classes = useStyles();

  const [user, setUser] = useState({});

  useEffect(() => {
    const loadUser = async () => {
      const result = await Axios.get('/api/user/me');

      setUser(result.data);
    };

    loadUser();
  }, []);

  return (
    <div className={classes.root}>
      <SkipNavigation />
      <CssBaseline />

      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <br />
        <Container
          component="div"
          className={classes.drawerHeader}
          disableGutters={true}
        >
          <Card elevation={0} style={{backgroundColor: '#fff0'}}>
            <CardActions>
              <Link to={'/'}>
                <CardMedia component="img" image={Image} alt="Colorful logo featuring the text 'METER HERO' with a gauge icon, and 'by STEMHERO' in smaller text below" />
              </Link>
            </CardActions>
          </Card>
        </Container>

        <Divider />
        <List>
          <li>
            <ListItem button component={Link} to={'/'}>
              <ListItemIcon>
                <HomeLinkIcon style={{color: 'white'}} />
              </ListItemIcon>
              <ListItemText primary={'Home'} />
            </ListItem>
          </li>
          <li>
            <ListItem button component={Link} to={'/teacher/classrooms'}>
              <ListItemIcon>
                <UsersLinkIcon style={{color: 'white'}} />
              </ListItemIcon>
              <ListItemText primary={'Classrooms'} />
            </ListItem>
          </li>
          <li>
            <ListItem button component={Link} to={'/teacher/students'}>
              <ListItemIcon>
                <StudentsLinkIcon style={{color: 'white'}} />
              </ListItemIcon>
              <ListItemText primary={'Students'} />
            </ListItem>
          </li>
        </List>
        <Divider />
      </Drawer>

      <main id="main-content" className={classes.content}>
        <Switch>
          <Route path={'/teacher'}>
            <Switch>
              <Route path={'/teacher/classrooms'}>
                <h1 style={screenReaderOnly()}>Manage Classrooms</h1>
                <TeacherClassroomsTable user={user} />
              </Route>
              <Route path={'/teacher/students'}>
                <h1 style={screenReaderOnly()}>Students</h1>
                <TeacherStudentsTable />
              </Route>
              <Route path={'/teacher'}>
                <h1>Teacher Dashboard</h1>
              </Route>
            </Switch>
          </Route>
        </Switch>
      </main>
    </div>
  );
}
